import React from 'react';
import PropTypes from 'prop-types';

import { MdOutlineEmail } from 'react-icons/md';
import { BiLink } from 'react-icons/bi';
import { shareSocialList, shareIconBtn, socialEmail } from './share-social-icons.module.scss';

const ShareSocialIcons = ({ title = `` }) => {
    const url =
        typeof window !== 'undefined'
            ? `https://www.paycheckcity.com${window.location.pathname}`
            : ``;

    const copyUrl = () => {
        navigator.clipboard.writeText(url);
    };

    return (
        <ul className={`${shareSocialList}`}>
            {url && (
                <>
                    <li>
                        <a
                            href={ `mailto:?subject=${title}&body=I wanted to share this article: ${url}` }
                            title="Share by email"
                            className={`${shareIconBtn} ${socialEmail} share-email-btn`}>
                            <div className="sr-only">Share by Email</div>
                            <MdOutlineEmail />
                        </a>
                    </li>
                    <li>
                        <button
                            type="button"
                            className={`${shareIconBtn} share-copy-btn`}
                            title="Copy URL"
                            onClick={copyUrl}>
                            <div className="sr-only">Copy URL</div>
                            <BiLink />
                        </button>
                    </li>{' '}
                </>
            )}
        </ul>
    );
};

ShareSocialIcons.propTypes = {
    title: PropTypes.string,
};

export default ShareSocialIcons;
